<script lang="ts" setup>
import { useImage } from '@/shared/composables/image'
import { useSanitize } from '@/services/useSanitize'
import { IEventEdit } from '@/enitites/event'

defineProps<{
  eventData: IEventEdit
}>()

const { getImageById } = useImage()
const { sanitize } = useSanitize()
</script>

<template>
  <div class="view-event">
    <v-img
      :src="getImageById(eventData.image, 800, 800, 'event')"
      class="view-event__image d-flex align-center mb-4"
    />
    <p><span class="view-event__bold-title">Event name:</span> {{ eventData.title }}</p>
    <p>
      <span class="view-event__bold-title">Location:</span>
      {{ eventData.locationAddress }}
    </p>
    <p><span class="view-event__bold-title">Website:</span> {{ eventData.website }}</p>
    <div>
      <span class="view-event__bold-title">Description:</span>
      <p
        class="rich-text"
        v-html="sanitize(eventData.description)"
      />
    </div>

    <p class="view-event__title">Admins</p>

    <v-chip
      v-for="(admin, i) in eventData.staff.admins"
      :key="i + 'a'"
      class="view-event__chip"
      color="transparent"
      large
      pill
    >
      <v-avatar left>
        <v-img :src="getImageById(admin.avatar, 100, 100, 'avatar')" />
      </v-avatar>
      {{ admin.dancerName }}
    </v-chip>

    <p class="view-event__title">Hosts</p>

    <v-chip
      v-for="(host, i) in eventData.staff.hosts"
      :key="i + 'x'"
      class="view-event__chip"
      color="transparent"
      large
      pill
    >
      <v-avatar left>
        <v-img :src="getImageById(host.avatar, 100, 100, 'avatar')" />
      </v-avatar>
      {{ host.dancerName }}
    </v-chip>

    <p class="view-event__title">DJs</p>
    <v-chip
      v-for="(Djs, i) in eventData.staff.djs"
      :key="i"
      class="view-event__chip"
      color="transparent"
      large
      pill
    >
      <v-avatar left>
        <v-img :src="getImageById(Djs.avatar, 100, 100, 'avatar')" />
      </v-avatar>
      {{ Djs.dancerName }}
    </v-chip>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/style/mixins';

.view-event {
  max-width: 400px;
  margin: 0 auto;

  &__image {
    position: relative;
    width: 100%;
    height: 400px;
    background: #6cace4;

    @media (max-width: $screen-sm) {
      height: 320px;
    }
  }

  &__title {
    margin: 16px 0;
    color: var(--color-dark-800);
    font-weight: var(--font-weight-semi-bold);
  }

  &__bold-title {
    font-weight: var(--font-weight-semi-bold);
  }

  &__chip {
    width: 100%;
    max-width: 265px;
    height: 34px !important;
    margin: 6px 0;
  }
}
</style>

<style lang="scss">
.rich-text {
  ul,
  li {
    list-style-type: inherit;
  }

  p {
    margin: 0 !important;
  }
}
</style>
